export enum CompanyStatusEnum {
    ACTIVE = 1,
    ARCHIVAL
}
